import { render, staticRenderFns } from "./AuthenticatedRoute.vue?vue&type=template&id=541352c6"
import script from "./AuthenticatedRoute.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports